<span [ngClass]="class"
      class="align-text-top"
      placement="right"
      [ngbTooltip]="tooltip">
  <span>{{ label }}</span>
</span>
